var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V496H496V16Z",
    fill: "#E74C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.751 87.4141L145.79 124.442H184.757L153.235 147.377L165.245 184.462L133.751 161.526L102.201 184.462L114.239 147.377L82.7173 124.442H121.685L133.751 87.4141Z",
    fill: "#F1C40F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M235.306 68.0449L234.507 80.8533L246.403 85.5888L233.994 88.7552L233.138 101.564L226.292 90.7236L213.883 93.89L222.07 84.0198L215.223 73.1797L227.119 77.9436L235.306 68.0449",
    fill: "#F1C40F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M279.094 109.58L273.247 120.99L282.289 130.09L269.652 128.036L263.776 139.475L261.806 126.781L249.14 124.755L260.551 118.964L258.611 106.298L267.626 115.369L279.093 109.578",
    fill: "#F1C40F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M265.944 161.555L269.852 173.765L282.717 173.788L272.305 181.29L276.27 193.499L265.915 185.968L255.503 193.499L259.497 181.29L249.142 173.759L261.95 173.782L265.944 161.544",
    fill: "#F1C40F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.249 200.693L234.393 213.502L246.317 218.266L233.88 221.404L233.054 234.212L226.207 223.372L213.77 226.538L221.957 216.697L215.11 205.828L227.034 210.592L235.25 200.693",
    fill: "#F1C40F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/CN.d94fa65009e0b1ec8a07e5fd75d83077.svg";
export { ForwardRef as ReactComponent };